import React from "react"
import { Redirect, Route, Switch } from "react-router"
import AppointmentsPage from "../AppointmentsPage"
import ApprovalRequest from "../ApprovalRequest"
import AddNewBed from "../Admin/CenterAdmin/AddNewBed/AddNewBed"
import AddNewReferral from "../Admin/CenterAdmin/AddNewReferral/AddNewReferral"
import BedManagement from "../Admin/CenterAdmin/BedManagement/BedManagement"
import ContactReferrals from "../Admin/CenterAdmin/ContactReferrals/ContactReferrals"
import EditManagePatients from "../Admin/CenterAdmin/EditManagePatients/EditManagePatients"
import MergePatients from "../Admin/CenterAdmin/MergePatients/MergePatients"
import PatientDirectory from "../frontDesk/patientDirectory/PatientDirectory"
import ManageStaff from "../Admin/CenterAdmin/ManageStaff/ManageStaff"
import AddPatient from "../AddPatient"
import PatientDetail from "../frontDesk/patientDetail/PatientDetail"
import PatientClinicalView from "../PatientClinicalView"
import BookAppointments from "../frontDesk/bookAppointment/BookAppointments"
import ConsultantProfile from "../frontDesk/consultantProfile/ConsultantProfile"
import ConsultantDirectory from "../frontDesk/consultantDirectory/ConsultantDirectory"
import ContactsPage from "../ContactsPage"
import EmergencyAccessProtocol from "../EmergencyAccessProtocol"
import EditManageStaff from "../Admin/CenterAdmin/EditManageStaff/EditManageStaff"
import AddManageStaff from "../Admin/CenterAdmin/AddManageStaff/AddManageStaff"
import ConsultantApprovalRequest from "../ConsultantApprovalRequest"
import BedAllocationRequest from "../BedAllocationRequest"
import MrdPage from "../Mrd"
import Admin from "../Admin"
import AutomaticIDGeneration from "../Admin/SystemAdmin/AutomaticIDGeneration"
import ManageCommunications from "../Admin/SystemAdmin/ManageCommunications"
import ManageCenters from "../Admin/SystemAdmin/ManageCenters"
import Billing from "../Admin/CenterAdmin/Billing/Billing"
import AddNewTax from "../Admin/CenterAdmin/AddNewTax/AddNewTax"
import AddCenter from "../Admin/SystemAdmin/AddCenter"
import AddNewPayment from "../Admin/CenterAdmin/Billing/AddNewPayment/AddNewPayment"
import TaxCatalog from "../Admin/CenterAdmin/Billing/TaxCatalog/TaxCatalog"
import ReportsView from "../ReportsView/ReportsView"
import MyDocumentsView from "../Patient/MyDocumentsView"
import AddNewServices from "../Admin/SystemAdmin/AddNewServices/CopyServices"
import MrdRaiseRequest from "../MrdRaiseRequest/MrdRaiseRequest"
import PendingRaiseRequests from "pages/PendingRaiseRequests/PendingRaiseRequests"
import MrdApprovalRequest from "pages/MrdApprovalRequest/MrdApprovalRequest"
import Prescriptions from "pages/Admin/SystemAdmin/Prescriptions/Prescriptions"
import FormsAndTemplates from "pages/Admin/SystemAdmin/FormsAndTemplates/FormsAndTemplates"
import QualityIndicator from "pages/Quality/QualityIndicator"
import Service from "pages/Admin/SystemAdmin/Service"
import BillingGeneralTable from "pages/frontDesk/billing/BillingGeneralTable/BillingGeneralTable"
import InvoicesForPatient from "pages/frontDesk/billing/PatientInvoices/InvoicesForPatient"
import MainBillingModule from "pages/frontDesk/billing/MainBilling/MainBillingModule"
import { SelfAssessment } from "pages/Patient/SelfAssessment/SelfAssessment"
import Payments from "pages/frontDesk/billing/MainBilling/components/payments/Payments"
import Refund from "pages/frontDesk/billing/MainBilling/components/refunds/Refund"
import AddNewMasterService from "pages/Admin/SystemAdmin/AddNewServices/AddNewMasterService"
import EditService from "pages/Admin/SystemAdmin/Service/EditService"
import PrintConfiguration from "pages/Admin/SystemAdmin/PrintConfiguration/PrintConfiguration"
import MyProfile from "pages/MyProfile/MyProfile"
import PendingDiscountApproval from "pages/AppointmentsPage/components/RMOPendingAppointmentComponent/PendingDiscountApproval"
import DiscountApproval from "pages/CenterAdmin/discountApproval/DiscountApproval"
import PendingDiscountList from "pages/AppointmentsPage/components/RMOPendingAppointmentComponent/PendingDiscountList"
import ViewAllCommon from "pages/AppointmentsPage/components/RMOPendingAppointmentComponent/ViewAllCommon"
import { FormsAndTemplatesV2 } from "pages/Admin/SystemAdmin/FormsAndTemplatesV2/FormsAndTemplatesV2"
import EditFormsAndTemplatesV2 from "pages/Admin/SystemAdmin/FormsAndTemplatesV2/EditFormsAndTemplatesV2"
import { FormEditor } from "pages/Admin/SystemAdmin/FormsAndTemplatesV2/FormEditor"
import { FormViewer } from "pages/Admin/SystemAdmin/FormsAndTemplatesV2/FormViewer"
import ChemoApprovalRequest from "pages/ChemoApprovalRequest/ChemoApprovalRequest"
import StaffAvailability from "pages/Admin/CenterAdmin/EditManageStaff/StaffAvailability"
import AddSubCategory from "pages/Admin/SystemAdmin/AddSubCategory/AddSubCategory"
import FormEditorMenu from "pages/Admin/SystemAdmin/FormsAndTemplatesV2/FormEditorMenu"
import SubCategoryMain from "pages/Admin/SystemAdmin/AddSubCategory/SubCategoryMain"
import ViewSubCategoryInfo from "pages/Admin/SystemAdmin/AddSubCategory/ViewSubCategoryInfo"
import AddNewFormTemplate from "pages/Admin/SystemAdmin/FormsAndTemplatesV2/AddNewFormTemplate/AddNewFormTemplate"
import Temporary from "pages/RMO/components/temporary/Temporary"
import StaffUnavailability from "pages/Admin/CenterAdmin/EditManageStaff/StaffUnavailability"
import PatientLedger from "pages/frontDesk/billing/MainBilling/components/patientLedger/PatientLedger"
import MainInvoiceReceipts from "pages/frontDesk/billing/MainBilling/components/patientReceipts/MainInvoiceReceipts"
import UserVerification from "pages/UserVerification/UserVerification"
import PrivacyPolicy from "pages/PrivacyPolicy/PrivacyPolicy"
import AppLinks from "pages/AppLinks/AppLinks"
import { useSelector } from "react-redux"
import { Box } from "@mui/material"
import CognitoOTPLogin from "cognito/CognitoOTPLogin/CognitoOTPLogin"
import NotFound from "pages/NotFound/NotFound"
import SessionExpiry from "pages/SessionExpiry/SessionExpiry"
import PatientTransfer from "pages/frontDesk/patientDirectory/PatientTransfer"
import ManagePaytmMerchants from "pages/Admin/SystemAdmin/ManagePaytmMerchants"
import AddPaytmMerchant from "pages/Admin/SystemAdmin/AddPaytmMerchant"
import AddPaytmTerminal from "pages/Admin/SystemAdmin/AddPaytmTerminal"

export default function RoutesNavigation({ marginLeft }: any) {

  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  function commonRoutes() {
    return [
      <Route exact path="/calendar" component={AppointmentsPage} key="appointments" />,
      <Route exact path="/patientList" component={PatientDirectory} key="patientList" />,
      <Route exact path="/patientList/:patientId" component={PatientDetail} key="patientDetail" />,
      <Route exact path="/contactUs" component={ContactsPage} key="contactUs" />,
      <Route exact path="/temporary-route" component={Temporary} key="temporaryRoute" />,
      <Route exact path="/reports" component={ReportsView} key="reports" />,
      <Route exact path="/myProfile" component={MyProfile} key="myProfile" />
    ]
  }

  function fdRmoCommonRoutes() {
    return [
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosis" />,
      <Route exact path="/bookAppointment" component={BookAppointments} key="bookAppointment" />,
      <Route exact path="/consultant" component={ConsultantDirectory} key="consultant" />,
      <Route exact path="/consultant/:consultantId" component={ConsultantProfile} key="consultantProfile" />,
      <Route exact path="/reports" component={ReportsView} key="reportsFdRmo" />
    ]
  }

  function frontDeskRoutes() {
    return [
      <Route exact path="/" key="redirect-frontDesk">
        <Redirect to="/calendar" />
      </Route>,
      ...commonRoutes(),
      <Route exact path="/addPatient" component={AddPatient} key="addPatient" />,
      <Route exact path="/editPatient/:patientId" component={AddPatient} key="editPatient" />,
      ...fdRmoCommonRoutes(),
      <Route exact path="/raiseRequest" component={MrdRaiseRequest} key="raiseRequest" />,
      <Route exact path="/discountApprovalRequest/:id/:invoiceId" component={PendingDiscountApproval} key="discountApprovalRequest" />,
      <Route exact path="/invoices" component={BillingGeneralTable} key="billingGeneralTable" />,
      <Route exact path="/invoices/:patientId" component={InvoicesForPatient} key="invoicesForPatient" />,
      <Route exact path="/invoices/patient/:invoiceId" component={MainBillingModule} key="mainBillingModule" />,
      <Route exact path="/invoices/payments/:invoiceId" component={Payments} key="payments" />,
      <Route exact path="/invoices/refund/:patientId" component={Refund} key="refund" />,
      <Route exact path="/invoices/patientLedger/:patientId" component={PatientLedger} key="patientLedger" />,
      <Route exact path="/invoices/patientReceipt/:patientId" component={MainInvoiceReceipts} key="mainInvoiceReceipts" />,
      <Route component={NotFound} key="notFound" />,
    ]
  }

  function rmoRoutes() {
    return [
      <Route exact path="/" key="redirect-rmo">
        <Redirect to="/calendar" />
      </Route>,
      ...commonRoutes(),
      ...fdRmoCommonRoutes(),
      <Route exact path="/editPatient/:patientId" component={AddPatient} key="editPatient" />,
      <Route exact path="/approvalRequest" component={ApprovalRequest} key="approvalRequest" />,
      <Route exact path="/raiseRequest" component={MrdRaiseRequest} key="raiseRequestRmo" />,
      <Route exact path="/viewAllRequest" component={ViewAllCommon} key="viewAllRequest" />,
      <Route exact path="/chemoApprovalRequest" component={ChemoApprovalRequest} key="chemoApprovalRequest" />
    ];
  }

  function consultantRoutes() {
    return [
      <Route exact path="/" key="redirect-consultant">
        <Redirect to="/calendar" />
      </Route>,
      ...commonRoutes(),
      <Route exact path="/editPatient/:patientId" component={AddPatient} key="editPatient" />,
      <Route exact path="/bookAppointment" component={BookAppointments} key="bookAppointmentConsultant" />,
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosisConsultant" />,
      <Route exact path="/editStaffUnavailability" component={StaffUnavailability} key="editStaffUnavailabilityConsultant" />,
      <Route exact path="/approvalRequest" component={ApprovalRequest} key="approvalRequestConsultant" />,
      <Route exact path="/consultantApprovalRequest" component={ConsultantApprovalRequest} key="consultantApprovalRequest" />,
      <Route exact path="/discountApprovalRequest/:id/:invoiceId" component={PendingDiscountApproval} key="discountApprovalRequestConsultant" />,
      <Route exact path="/chemoApprovalRequest" component={ChemoApprovalRequest} key="chemoApprovalRequestConsultant" />,
      <Route exact path="/discountList" component={PendingDiscountList} key="discountList" />,
      <Route exact path="/reports" component={ReportsView} key="reportsConsultant" />,
      <Route exact path="/viewAllRequest" component={ViewAllCommon} key="viewAllRequestConsultant" />,
      <Route exact path="/raiseRequest" component={MrdRaiseRequest} key="raiseRequestConsultant" />
    ];
  }

  function subConsultantRoutes() {
    return [
      <Route exact path="/" key="redirect-subConsultant">
        <Redirect to="/calendar" />
      </Route>,
      ...commonRoutes(),
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosisSubConsultant" />,
      <Route exact path="/editStaffUnavailability" component={StaffUnavailability} key="editStaffUnavailabilitySubConsultant" />,
      <Route exact path="/reports" component={ReportsView} key="reportsSubConsultant" />,
      <Route exact path="/raiseRequest" component={MrdRaiseRequest} key="raiseRequestSubConsultant" />
    ];
  }

  function homeCareRoutes() {
    return [
      <Route exact path="/" key="redirect-homeCare">
        <Redirect to="/calendar" />
      </Route>,
      ...commonRoutes(),
      <Route exact path="/bookAppointment" component={BookAppointments} key="bookAppointmentHomeCare" />,
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosisHomeCare" />,
      <Route exact path="/approvalRequest" component={ApprovalRequest} key="approvalRequestHomeCare" />,
      <Route exact path="/consultantApprovalRequest" component={ConsultantApprovalRequest} key="consultantApprovalRequestHomeCare" />,
      <Route exact path="/editPatient/:patientId" component={AddPatient} key="editPatientHomeCare" />,
      <Route exact path="/invoices" component={BillingGeneralTable} key="invoicesHomeCare" />,
      <Route exact path="/invoices/:patientId" component={InvoicesForPatient} key="invoicesPatientHomeCare" />,
      <Route exact path="/invoices/patient/:invoiceId" component={MainBillingModule} key="invoicesPatientInvoiceHomeCare" />,
      <Route exact path="/invoices/payments/:invoiceId" component={Payments} key="invoicesPaymentsHomeCare" />,
      <Route exact path="/invoices/refund/:patientId" component={Refund} key="invoicesRefundHomeCare" />,
      <Route exact path="/invoices/patientLedger/:patientId" component={PatientLedger} key="invoicesPatientLedgerHomeCare" />,
      <Route exact path="/invoices/patientReceipt/:patientId" component={MainInvoiceReceipts} key="invoicesPatientReceiptHomeCare" />,
      <Route exact path="/reports" component={ReportsView} key="reportsHomeCare" />,
      <Route exact path="/raiseRequest" component={MrdRaiseRequest} key="raiseRequestHomeCare" />
    ];
  }

  function patientRoutes() {
    return [
      <Route exact path="/" key="redirect-patient">
        <Redirect to="/patientDetail" />
      </Route>,
      <Route exact path="/patientDetail" component={PatientDetail} key="patientDetailPatient" />,
      <Route exact path="/bookAppointment" component={BookAppointments} key="bookAppointmentPatient" />,
      <Route exact path="/contactUs" component={ContactsPage} key="contactUsPatient" />,
      <Route exact path="/emergency" component={EmergencyAccessProtocol} key="emergencyPatient" />,
      <Route exact path="/editPatient/:patientId" component={AddPatient} key="editPatientPatient" />,
      <Route exact path="/selfAssesment" component={SelfAssessment} key="selfAssessmentPatient" />,
      <Route exact path="/reports" component={ReportsView} key="reportsPatient" />,
      <Route exact path="/myDocuments" component={MyDocumentsView} key="myDocumentsPatient" />
    ];
  }

  function nurseRoutes() {
    return [
      <Route exact path="/" key="redirect-nurse">
        <Redirect to="/calendar" />
      </Route>,
      ...commonRoutes(),
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosisNurse" />,
      <Route exact path="/emergency" component={EmergencyAccessProtocol} key="emergencyNurse" />,
      <Route exact path="/bedRequests" component={BedAllocationRequest} key="bedRequests" />,
      <Route exact path="/reports" component={ReportsView} key="reportsNurse" />,
      <Route exact path="/raiseRequest" component={MrdRaiseRequest} key="raiseRequestNurse" />
    ];
  }

  function mrdRoutes() {
    return [
      <Route exact path="/" key="redirect-mrd">
        <Redirect to="/mrd" />
      </Route>,
      <Route exact path="/mrd" component={MrdPage} key="mrd" />,
      <Route exact path="/patientList" component={PatientDirectory} key="patientListMrd" />,
      <Route exact path="/patientList/:patientId" component={PatientDetail} key="patientListDetailMrd" />,
      <Route exact path="/contactUs" component={ContactsPage} key="contactUsMrd" />,
      <Route exact path="/approvalRequest" component={ApprovalRequest} key="approvalRequestMrd" />,
      <Route exact path="/mrdPendingApprovalRequests" component={PendingRaiseRequests} key="mrdPendingApprovalRequests" />,
      <Route exact path="/mrdApprovalRequest" component={MrdApprovalRequest} key="mrdApprovalRequest" />,
      <Route exact path="/myProfile" component={MyProfile} key="myProfileMrd" />,
      <Route exact path="/reports" component={ReportsView} key="reportsMrd" />,
      <Route exact path="/viewAllRequest" component={ViewAllCommon} key="viewAllRequestMrd" />,
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosisMrd" />
    ];
  }

  function commonAdminRoutes() {
    return [
      <Route exact path="/home" component={Admin} key="homeAdmin" />,
      <Route exact path="/managePatients" component={PatientDirectory} key="managePatients" />,
      <Route exact path="/transferPatients" component={PatientTransfer} key="transferPatients" />,
      <Route exact path="/temporary-route" component={Temporary} key="temporaryRouteAdmin" />,
      <Route exact path="/managePatients/:patientId" component={EditManagePatients} key="editManagePatients" />,
      <Route exact path="/manageStaff" component={ManageStaff} key="manageStaff" />,
      <Route exact path="/editManageStaff" component={EditManageStaff} key="editManageStaffAdmin" />,
      <Route exact path="/editStaffAvailability" component={StaffAvailability} key="editStaffAvailability" />,
      <Route exact path="/editStaffUnavailability" component={StaffUnavailability} key="editStaffUnavailability" />,
      <Route exact path="/addManageStaff" component={AddManageStaff} key="addManageStaff" />,
      <Route exact path="/contactReferrals" component={ContactReferrals} key="contactReferrals" />,
      <Route exact path="/addNewReferrals" component={AddNewReferral} key="addNewReferrals" />,
      <Route exact path="/copyServices" component={AddNewServices} key="copyServices" />,
      <Route exact path="/Services" component={AddNewMasterService} key="services" />,
      <Route exact path="/editServices" component={EditService} key="editServices" />,
      <Route exact path="/printConfiguration" component={PrintConfiguration} key="printConfiguration" />,
      <Route exact path="/bedManagement" component={BedManagement} key="bedManagement" />,
      <Route exact path="/addNewBed" component={AddNewBed} key="addNewBed" />,
      <Route exact path="/mergePatients" component={MergePatients} key="mergePatients" />,
      <Route exact path="/contactUs" component={ContactsPage} key="contactUsAdmin" />,
      <Route exact path="/addNewTax" component={AddNewTax} key="addNewTax" />,
      <Route exact path="/addNewPayment" component={AddNewPayment} key="addNewPayment" />,
      <Route exact path="/billing/taxCatalog" component={TaxCatalog} key="taxCatalog" />,
      <Route exact path="/myProfile" component={MyProfile} key="myProfileAdmin" />,
      <Route exact path="/service" component={Service} key="serviceAdmin" />,
      <Route exact path="/reports" component={ReportsView} key="reportsAdmin" />,
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosisAdmin" />
    ]
  }

  function systemAdminRoutes() {
    return [
      <Route exact path="/" key="redirect-systemAdmin">
        <Redirect to="/home" />
      </Route>,
      ...commonAdminRoutes(),
      <Route exact path="/automaticIDGeneration" component={AutomaticIDGeneration} key="automaticIDGeneration" />,
      <Route exact path="/billing/admin" component={Billing} key="billingAdmin" />,
      <Route exact path="/manageCommunications" component={ManageCommunications} key="manageCommunications" />,
      <Route exact path="/manageCenters" component={ManageCenters} key="manageCenters" />,
      <Route exact path="/service" component={Service} key="serviceSystemAdmin" />,
      <Route exact path="/manageCenters/add" component={AddCenter} key="addCenter" />,
      <Route exact path="/manageCenters/:id" component={AddCenter} key="editCenter" />,
      <Route exact path="/forms" component={FormsAndTemplates} key="forms" />,
      <Route exact path="/forms-v2" component={FormsAndTemplatesV2} key="formsV2" />,
      <Route exact path="/edit-forms-v2/:id" component={EditFormsAndTemplatesV2} key="editFormsV2" />,
      <Route exact path="/edit-forms-menu/:id" component={FormEditorMenu} key="editFormsMenu" />,
      <Route exact path="/edit-form-json" component={FormEditor} key="editFormJson" />,
      <Route exact path="/view-form" component={FormViewer} key="viewForm" />,
      <Route exact path="/add-form-template" component={AddNewFormTemplate} key="addFormTemplate" />,
      <Route exact path="/prescriptions" component={Prescriptions} key="prescriptions" />,
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosisSystemAdmin" />,
      <Route exact path="/addSubCategory" component={AddSubCategory} key="addSubCategory" />,
      <Route exact path="/SubCategoryMenu" component={SubCategoryMain} key="subCategoryMenu" />,
      <Route exact path="/viewSubCategoryInfo" component={ViewSubCategoryInfo} key="viewSubCategoryInfo" />,
      <Route exact path="/managePaytmMerchants" component={ManagePaytmMerchants} key="managePaytmMerchants" />,
      <Route exact path="/managePaytmMerchants/add" component={AddPaytmMerchant} key="addPaytmMerchant" />,
      <Route exact path="/managePaytmMerchants/:id" component={AddPaytmMerchant} key="editCenter" />,
      <Route exact path="/managePaytmMerchants/:id/terminal" component={AddPaytmTerminal} key="terminal" />,
    ];
  }

  function centerAdminRoutes() {
    return [
      <Route exact path="/" key="redirect-centerAdmin">
        <Redirect to="/home" />
      </Route>,
      <Route exact path="/contactUs" component={ContactsPage} key="contactUsCenterAdmin" />,
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosisCenterAdmin" />,
      ...commonAdminRoutes(),
      <Route exact path="/approvalRequests" component={DiscountApproval} key="approvalRequests" />,
      <Route exact path="/discountApprovalRequest/:id/:invoiceId" component={PendingDiscountApproval} key="discountApprovalRequestCenterAdmin" />,
      <Route exact path="/viewAllRequest" component={ViewAllCommon} key="viewAllRequestCenterAdmin" />
    ];
  }

  function qualityRoutes() {
    return [
      <Route exact path="/" key="redirect-quality">
        <Redirect to="/qualityIndicator" />
      </Route>,
      <Route exact path="/qualityIndicator" component={QualityIndicator} key="qualityIndicator" />,
      <Route exact path="/reports" component={ReportsView} key="reportsQuality" />,
      <Route exact path="/contactUs" component={ContactsPage} key="contactUsQuality" />,
      <Route exact path="/myProfile" component={MyProfile} key="myProfileQuality" />,
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosisQuality" />
    ];
  }

  function insuranceRoutes() {
    return [
      <Route exact path="/" key="redirect-insurance">
        <Redirect to="/invoices" />
      </Route>,
      <Route exact path="/editPatient/:patientId" component={AddPatient} key="editPatientInsurance" />,
      <Route exact path="/invoices" component={BillingGeneralTable} key="invoicesInsurance" />,
      <Route exact path="/discountApprovalRequest/:id/:invoiceId" component={PendingDiscountApproval} key="discountApprovalRequestInsurance" />,
      <Route exact path="/invoices/:patientId" component={InvoicesForPatient} key="invoicesPatientInsurance" />,
      <Route exact path="/invoices/patient/:invoiceId" component={MainBillingModule} key="invoicesPatientInvoiceInsurance" />,
      <Route exact path="/invoices/payments/:invoiceId" component={Payments} key="invoicesPaymentsInsurance" />,
      <Route exact path="/invoices/refund/:patientId" component={Refund} key="invoicesRefundInsurance" />,
      <Route exact path="/invoices/patientLedger/:patientId" component={PatientLedger} key="invoicesPatientLedgerInsurance" />,
      <Route exact path="/invoices/patientReceipt/:patientId" component={MainInvoiceReceipts} key="invoicesPatientReceiptInsurance" />,
      <Route exact path="/reports" component={ReportsView} key="reportsInsurance" />,
      <Route exact path="/contactUs" component={ContactsPage} key="contactUsInsurance" />,
      <Route exact path="/myProfile" component={MyProfile} key="myProfileInsurance" />,
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosisInsurance" />
    ];
  }

  function accountantRoutes() {
    return [
      <Route exact path="/" key="redirect-accountant">
        <Redirect to="/reports" />
      </Route>,
      <Route exact path="/contactUs" component={ContactsPage} key="contactUsAccountant" />,
      <Route exact path="/reports" component={ReportsView} key="reportsAccountant" />,
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosisAccountant" />
    ];
  }

  function ceoRoutes() {
    return [
      <Route exact path="/" key="redirect-ceo">
        <Redirect to="/reports" />
      </Route>,
      <Route exact path="/contactUs" component={ContactsPage} key="contactUsCeo" />,
      <Route exact path="/reports" component={ReportsView} key="reportsCeo" />,
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosisCeo" />
    ];
  }

  function marketingRoutes() {
    return [
      <Route exact path="/" key="redirect-marketing">
        <Redirect to="/reports" />
      </Route>,
      <Route exact path="/reports" component={ReportsView} key="reportsMarketing" />,
      <Route exact path="/contactUs" component={ContactsPage} key="contactUsMarketing" />,
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosisMarketing" />,
      <Route exact path="/myProfile" component={MyProfile} key="myProfileMarketing" />
    ];
  }

  function operationsRoutes() {
    return [
      <Route exact path="/" key="redirect-operations">
        <Redirect to="/home" />
      </Route>,
      ...commonAdminRoutes(),
      <Route exact path="/automaticIDGeneration" component={AutomaticIDGeneration} key="automaticIDGenerationOperations" />,
      <Route exact path="/billing/admin" component={Billing} key="billingAdminOperations" />,
      <Route exact path="/manageCommunications" component={ManageCommunications} key="manageCommunicationsOperations" />,
      <Route exact path="/manageCenters" component={ManageCenters} key="manageCentersOperations" />,
      <Route exact path="/service" component={Service} key="serviceOperations" />,
      <Route exact path="/manageCenters/add" component={AddCenter} key="addCenterOperations" />,
      <Route exact path="/manageCenters/:id" component={AddCenter} key="editCenterOperations" />,
      <Route exact path="/forms" component={FormsAndTemplates} key="formsOperations" />,
      <Route exact path="/forms-v2" component={FormsAndTemplatesV2} key="formsV2Operations" />,
      <Route exact path="/edit-forms-v2/:id" component={EditFormsAndTemplatesV2} key="editFormsV2Operations" />,
      <Route exact path="/edit-forms-menu/:id" component={FormEditorMenu} key="editFormsMenuOperations" />,
      <Route exact path="/prescriptions" component={Prescriptions} key="prescriptionsOperations" />,
      <Route exact path="/reports" component={ReportsView} key="reportsOperations" />,
      <Route exact path="/patientDiagnosis/:patientId" component={PatientClinicalView} key="patientDiagnosisOperations" />,
      <Route exact path="/addSubCategory" component={AddSubCategory} key="addSubCategoryOperations" />,
      <Route exact path="/SubCategoryMenu" component={SubCategoryMain} key="subCategoryMenuOperations" />,
      <Route exact path="/viewSubCategoryInfo" component={ViewSubCategoryInfo} key="viewSubCategoryInfoOperations" />
    ];
  }

  const openRoutes = () => {
    return [
      <Route exact path="/login" component={CognitoOTPLogin} key="login" />,
      <Route exact path="/verify" component={UserVerification} key="verify" />,
      <Route exact path="/payments" component={Payments} key="paymentsOpen" />,
      <Route exact path="/privacy-policy" component={PrivacyPolicy} key="privacyPolicy" />,
      <Route exact path="/app-links" component={AppLinks} key="app-links" />,
      <Route exact path="/session-expiry" component={SessionExpiry} key="sessionExpiry" />
    ]
  }

  function fetchRoutes() {
    const obj: any = {
      front_desk: frontDeskRoutes(),
      rmo: rmoRoutes(),
      consultant: consultantRoutes(),
      nutritionist: subConsultantRoutes(),
      physiotherapist: subConsultantRoutes(),
      psychologist: subConsultantRoutes(),
      genetic_counsellor: subConsultantRoutes(),
      home_care_rmo: homeCareRoutes(),
      home_care_nurse: homeCareRoutes(),
      mrd: mrdRoutes(),
      patient: patientRoutes(),
      nurse: nurseRoutes(),
      center_admin: centerAdminRoutes(),
      system_admin: systemAdminRoutes(),
      operations: operationsRoutes(),
      quality: qualityRoutes(),
      insurance: insuranceRoutes(),
      accountant: accountantRoutes(),
      ceo: ceoRoutes(),
      marketing: marketingRoutes(),
      management: ceoRoutes(),
      bill_desk: ceoRoutes()
    }
    return obj[userRole?.toLowerCase()]
  }


  return (
    <Box
      style={{
        marginLeft: marginLeft,
      }}>
      <Switch>
        {openRoutes()}
        {userRole && userDetail && fetchRoutes()}
      </Switch>
    </Box>
  );
}